import queryString from 'query-string';

import { createAxiosInstance } from '~/plugins/axios.plugin';

class RubricService {
  constructor() {
    this.client = createAxiosInstance({ baseURL: process.env.PLATAFORMA_API_V2, useAccessToken: true });
  }

  getAllRubrics(params) {
    const stringifiedQuery = queryString.stringify({
      order       : params.sortBy,
      perPage     : params.itemsPerPage,
      page        : params.page,
      filter      : params.filter,
      isPaginated : params.isPaginated
    }, { skipNull: true, skipEmptyString: true });

    return this.client.get(`/content${params.academicMainId ? '/academic-main/' + params.academicMainId: ''}/rubrics?${stringifiedQuery}`);
  }

  getRubricById(params) {
    return this.client.get(`/content${params.academicMainId ? '/academic-main/' + params.academicMainId: ''}/rubrics/${params.id}`);
  }

  deleteRubricById(params) {
    return this.client.delete(`/content${params.academicMainId ? '/academic-main/' + params.academicMainId: ''}/rubrics/${params.id}`);
  }

  createRubric(payload) {
    return this.client.post(`/content${payload.academicMainId ? '/academic-main/' + payload.academicMainId: ''}/rubrics`, payload.params);
  }

  editRubric(payload) {
    return this.client.put(`/content${payload.academicMainId ? '/academic-main/' + payload.academicMainId: ''}/rubrics/${payload.params.id}`, payload.params);
  }
};

export default new RubricService();
